import React from "react";
import { Button } from "react-bootstrap";
import getClasses from "utils/getClasses";

import styles from "./styles.module.scss";

const ToggleVisibility = ({
  children,
  showAll,
  setShowAll,
  showAllText,
  showLessText,
  onToggle,
}) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child);
    }
    return child;
  });

  return (
    <div className={showAll ? "" : styles["partial-container"]}>
      {childrenWithProps}
      <div
        className={
          showAll
            ? styles["button-area"]
            : getClasses(styles["button-area"], styles["button-area--fixed"])
        }
      >
        <Button
          className={"smoothed"}
          variant="link"
          onClick={() => {
            onToggle && onToggle();
            setShowAll(!showAll);
          }}
        >
          {showAll ? showLessText : showAllText}
        </Button>
      </div>
    </div>
  );
};

export default ToggleVisibility;
